import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { createRegisterSchema } from './auth.schema'
import type { RegisterFormValues } from './auth.schema'

export function useRegisterForm() {
  const { t } = useTranslation()
  const form = useForm<RegisterFormValues>({
    resolver: zodResolver(createRegisterSchema(t)),
    defaultValues: {
      fullName: '',
      email: '',
      password: '',
      confirmPassword: '',
      termsAccepted: false,
    },
    mode: 'onSubmit',
  })

  const onSubmit = form.handleSubmit(async () => {
    // API integration will be connected later.
  })

  return { form, onSubmit }
}
